/* src/app/pages/menu/menu.page.scss */
ion-header {
  box-shadow: none;
  background: #000;
}
.search-row {
  padding: 0 14px 12px;
}
.search-bar-wrapper {
  width: 100%;
}
.search-bar-inner {
  display: flex;
  align-items: center;
  background: #1a1a1a;
  border: 1px solid #383838;
  border-radius: 50px;
  padding: 0 16px;
  height: 48px;
  gap: 12px;
  transition: border-color 0.2s ease;
}
.search-bar-inner:focus-within {
  border-color: #00FFFF;
}
.search-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  opacity: 0.8;
}
.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.01em;
}
.search-input::placeholder {
  color: #888;
  font-size: 14px;
}
.search-clear {
  background: transparent;
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  flex-shrink: 0;
  transition: color 0.15s;
}
.search-clear:hover {
  color: #fff;
}
.info-bar {
  background: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
}
.info-bar .info-bar-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.info-bar .info-bar-content .info-text {
  font-size: 12px;
  line-height: 1.4;
  color: #333;
}
@media (min-width: 991px) {
  .info-bar .info-bar-content .info-text {
    font-size: 14px;
  }
}
.info-bar .info-bar-content .info-text .info-link {
  color: var(--ion-color-primary);
  text-decoration: underline;
  font-weight: 500;
}
.info-bar .info-bar-content .info-text .info-link:hover {
  color: var(--ion-color-primary-tint);
}
.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px 15px;
}
.back-icon {
  height: 22px;
  width: 22px;
}
.logo-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: absolute;
  left: 0;
  right: 0;
}
.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 30px;
  width: 190px;
}
.right-slot {
  display: flex;
  align-items: center;
}
.right-slot .table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #fff;
  height: 26px;
  padding-inline: 9px;
  margin-right: 14px;
}
.right-slot .table-chip-text {
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #000;
  margin-right: 6px;
}
.right-slot .table-chip-number {
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
}
.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 10px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    margin: 0 auto;
    max-width: 1300px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
}
.main_row .order-col {
  padding-top: 23px;
}
.item-col {
  margin-bottom: 12px;
  padding: 0px 6px;
}
@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}
.category-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 3px;
  align-items: start;
  padding-left: 7px;
  padding-top: 10px;
  padding-bottom: 20px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-size: 20px;
  text-align: center;
  color: #fff;
}
.divider-name {
  border: 3px solid #00FFFF;
  width: 100.77px;
}
.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}
.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}
.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}
.filers_section {
  background: var(--color-background-alt);
}
@media (max-width: 992px) {
  .filers_section {
    border-bottom: 1px solid #222222;
  }
}
.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
}
.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}
.main-content::part(scroll) {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.display-flex {
  display: flex;
}
.main-category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0;
  border-bottom: 1px solid #383838;
  margin-bottom: 1.2rem;
}
@media (min-width: 991px) {
  .main-category-list {
    justify-content: center;
  }
}
.main-category-list::-webkit-scrollbar {
  display: none;
}
.main-category-list ion-chip.main-category {
  flex: 0 0 auto;
  height: 48px;
  max-width: fit-content;
  margin: 0;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  --background: transparent;
  border-radius: 0;
  border: none;
  border-bottom: 3px solid transparent;
  transition: all 200ms linear;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .main-category-list ion-chip.main-category {
    height: 52px;
    padding: 0 30px;
  }
  .main-category-list ion-chip.main-category:hover:not(.selected) {
    border-bottom-color: rgba(0, 255, 255, 0.5);
  }
  .main-category-list ion-chip.main-category:hover:not(.selected) p {
    color: #00FFFF;
  }
}
.main-category-list ion-chip.main-category:first-child {
  margin-left: 15px;
}
.main-category-list ion-chip.main-category:last-child {
  margin-right: 15px;
}
.main-category-list ion-chip.main-category p {
  font-size: 13px;
  line-height: 120%;
  letter-spacing: 0.06em;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  margin: 0;
  white-space: nowrap;
}
@media (min-width: 991px) {
  .main-category-list ion-chip.main-category p {
    font-size: 15px;
  }
}
.main-category-list ion-chip.main-category.selected {
  transition: all 200ms linear;
  background: transparent;
  border-bottom-color: #004FFF;
}
.category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-bottom: 18px;
  height: 53px;
}
@media (min-width: 991px) {
  .category-list {
    justify-content: center;
    flex-grow: 1;
  }
  .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
  }
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list ion-chip {
  flex: 0 0 auto;
  height: 30px;
  max-width: fit-content;
  margin: 0px 3px;
  --background: transparent;
  border-radius: 50px;
  border: 1px solid #383838;
  transition: 200ms linear;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
@media (min-width: 991px) {
  .category-list ion-chip {
    height: 35px;
  }
  .category-list ion-chip:hover {
    --background: #00FFFF;
  }
  .category-list ion-chip:hover p {
    color: #000;
  }
}
.category-list ion-chip:first-child {
  margin-left: 15px;
}
.category-list ion-chip:last-child {
  margin-right: 15px;
}
.category-list ion-chip p {
  font-size: 13px;
  line-height: 120%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
@media (min-width: 991px) {
  .category-list ion-chip p {
    font-size: 14px;
  }
}
.category-list ion-chip ion-icon,
.category-list ion-chip ion-img {
  height: 31px;
  width: 31px;
  margin-right: 5px;
}
.category-list ion-chip.selected {
  transition: 200ms linear;
  background: #00FFFF;
}
.category-list ion-chip.selected p {
  color: #000;
}
.category-list ion-chip.selected ion-icon {
  fill: var(--ion-color-primary);
}
.filters-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-top: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter,
.filters-block .vegan-filter {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.filters-block .common-filter {
  border-right: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter .filter-icon {
  height: 100%;
  width: 35px;
  margin-right: 7px;
}
.filters-block .switcher {
  position: relative;
  background: var(--ion-color-primary);
  border-radius: 50px;
  height: 23px;
  width: 63px;
  border: 1px solid #000000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 6px;
}
.filters-block .switcher .switch-toggler {
  position: absolute;
  left: 0%;
  top: 0%;
  height: 100%;
  width: 42px;
  background-color: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transition: left 0.3s ease-in-out, background 0.3s ease-in-out;
}
.filters-block .switcher .switch-toggler.selected {
  left: 32%;
  background: var(--ion-color-primary);
}
.filters-block .filters-text {
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fbfbfb;
}
.drink-subcategory-filters {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 12px 14px;
  gap: 8px;
  border-bottom: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.drink-subcategory-filters::-webkit-scrollbar {
  display: none;
}
@media (min-width: 991px) {
  .drink-subcategory-filters {
    justify-content: center;
    flex-wrap: wrap;
  }
}
.drink-subcategory-filters .subcategory-chip {
  flex: 0 0 auto;
  background: transparent;
  border: 1px solid #00FFFF;
  border-radius: 16px;
  padding: 6px 14px;
  margin: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 30px;
}
.drink-subcategory-filters .subcategory-chip p {
  font-size: 11px;
  font-weight: 500;
  color: #00FFFF;
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.drink-subcategory-filters .subcategory-chip.selected {
  background: #00FFFF;
  border-color: #00FFFF;
}
.drink-subcategory-filters .subcategory-chip.selected p {
  color: #000;
  font-weight: 600;
}
.drink-subcategory-filters .subcategory-chip:hover:not(.selected) {
  background: rgba(0, 255, 255, 0.15);
}
@media (min-width: 991px) {
  .drink-subcategory-filters .subcategory-chip:hover:not(.selected) {
    border-color: #00FFFF;
  }
}
.more {
  min-height: 400px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}
.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}
.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.max-height-100 {
  max-height: 100%;
}
.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  -webkit-box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
  -moz-box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}
.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #f2dbd9;
  color: var(--color-black);
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 70px;
    font-size: 14px;
  }
}
.show-basket {
  min-width: 200px;
  position: relative;
  min-height: 35px;
}
.show-basket ion-icon {
  margin-right: 10px;
  color: white;
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}
.show-basket:hover {
  --background: var(--ion-color-primary) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
}
/*# sourceMappingURL=menu.page.css.map */
